import React from 'react';

const About = () => {
  return (
    <section id="about" className="relative py-20 md:py-32 overflow-hidden">
      {/* Premium Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-white to-purple-50/50"></div>
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: `radial-gradient(circle at 20% 50%, rgba(124, 58, 237, 0.1) 0%, transparent 50%),
                         radial-gradient(circle at 80% 80%, rgba(124, 58, 237, 0.08) 0%, transparent 50%)`
      }}></div>
      
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-4 bg-purple-100 rounded-2xl transform rotate-3"></div>
              <img
                src="https://customer-assets.emergentagent.com/job_c8ba1316-fe9a-4786-bbb1-586136be868e/artifacts/5ch00nxt_Elegance%20By%20AG-2571.jpg"
                alt="Wanda Roman - Community Leader"
                className="relative rounded-2xl shadow-2xl w-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900">
                Meet Wanda Roman
              </h2>
              <div className="w-24 h-1.5 bg-purple-700"></div>
            </div>

            <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
              <p>
                Wanda Roman has served the Kissimmee community for over 20 years as a business owner and community leader. She has supported families, empowered small businesses, and contributed to the growth and strength of the city.
              </p>
              <p>
                Now, she is running for City Commissioner Seat 2 with a deep commitment to serve at a higher level. As Kissimmee continues to grow, Wanda brings experience, dedication, and the courage to make decisions that create opportunity for all.
              </p>
              <p className="text-purple-700 font-semibold text-xl italic">
                "My commitment is to every family, every business, and every voice in our community. Together, we will build a stronger Kissimmee."
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-purple-700">20+</div>
                <div className="text-sm text-gray-600 mt-2">Years of Service</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-purple-700">100s</div>
                <div className="text-sm text-gray-600 mt-2">Families Helped</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-purple-700">1</div>
                <div className="text-sm text-gray-600 mt-2">Shared Vision</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
